import { createContext } from 'react'

export const Ex3Context = createContext<'control' | 'experiment'>('control')
